import './index.css';
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/solid.css";

// import registerServiceWorker from './registerServiceWorker';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { initializeUser } from './actions/auth';
import { Provider } from 'react-intl-redux';
import configureStore from './configureStore';

import { LocaleProvider } from 'antd';
import ruRU from 'antd/lib/locale-provider/ru_RU';

import Welcome from './welcome';
import Login from './views/Login';
import Layout from './views/Layout';
import ViewerMain from './views/Viewer/main.jsx';
import ViewerRoots from './views/Viewer/roots.jsx';
import ViewerDeepCT from './views/Viewer/deepct.jsx';
import PlanStandartViewerV4 from './views/ViewerV4/plan-standart.jsx';

import {addLocaleData} from 'react-intl'
import enLocaleData from 'react-intl/locale-data/en'
import ruLocaleData from 'react-intl/locale-data/ru'
import localRuMessages from './locale/ru.js'
import localEnMessages from './locale/en.js'

import { Button } from 'antd';

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter
} from 'react-router-dom';

addLocaleData([
    ...enLocaleData,
    ...ruLocaleData,
])

const store = configureStore({
  intl: {
          locale: 'en',
          messages: localEnMessages
    }
});

class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let WelcomeWithRouter = withRouter(Welcome);
    return (
      <LocaleProvider locale={ruRU}>
        <Provider store={store}>
          <Router>
            <div style={{width: '100%', height: '100%'}}>
              <Route path="/" render={ ({location}) => {
                if (!store.getState().user.username) {
                    store.dispatch(initializeUser());
                    return <WelcomeWithRouter to={location.pathname} />
                } else { 
                  return null
                }
              }}/>
              <Switch>
                <Route path="/login" component={Login}/>
                <Route path="/case/control/plan-standart/:uuid" component={ViewerMain}/>
                <Route path="/case/control/plan-roots/:uuid" component={ViewerRoots}/>
                <Route path="/case/control/plan-deep-ct/:uuid" component={ViewerDeepCT}/>
                <Route path="/case/control/plan-standard-orthostudio/:uuid" component={PlanStandartViewerV4}/>
                <Route path="/case/control/plan-standard-3shape-1c/:uuid" component={PlanStandartViewerV4}/>
                <Route path="/case/control/plan-standard-3shape-color/:uuid" component={PlanStandartViewerV4}/>
                <Route path="/case/control/plan-standard-archform-1c/:uuid" component={PlanStandartViewerV4}/>
                <Route path="/case/control/plan-standard-onyxceph/:uuid" component={PlanStandartViewerV4}/>
                <Route path="/case/control/plan-standard-orthostudio-v5/:uuid" component={PlanStandartViewerV4}/>
                <Route path="/case/control/plan-standard-suresmile-sou/:uuid" component={PlanStandartViewerV4}/>
                <Route path="/case/control/plan-standard-nemo/:uuid" component={PlanStandartViewerV4}/>
                <Route path="/case/control/teeth-alignment-modelling/:uuid" component={ViewerMain}/>
                <Route path="/" component={Layout}/>
                <Redirect to="/login"/>
              </Switch>
            </div>
          </Router>
        </Provider>
      </LocaleProvider>
    );
  }
}

ReactDOM.render(
  <App user={store.getState()}/>, 
  document.getElementById('root')
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js